import { ListItemText as MUIListItemText, ListItemTextProps as MUIListItemTextProps } from '@mui/material';

export interface ListItemTextProps extends MUIListItemTextProps {}

export const ListItemText = MUIListItemText;
